<template>
  <div class="BoyoTable">
    <div ref="tableMode_one"
         class="tableMode_one">
      <el-table :data="tableInfo.data"
                ref="table"
                highlight-current-row
                :resizable="tableInfo.resizable?tableInfo.resizable:true"
                :border="tableInfo.resizable?tableInfo.resizable:true"
                :max-height="tableInfo.height?tableInfo.height:maxHeight"
                :row-key="tableInfo.key"
                :default-expand-all="tableInfo.expand"
                :tree-props="tableInfo.props"
                tooltip-effect="dark"
                :row-style="tableRowClassName"
                :header-cell-style="{background:'#eff3f8',color:'black','border-bottom':'1px solid #cccccc','font-size':'16px',padding:'2px 0'}"
                :cell-style="{padding:'4px','border-left':'1px solid #ccc'}"
                @row-dblclick="rowDblclick"
                @selection-change="handleSelectionChange"
                @select-all="selectChange"
                @row-click="rowClick">
        <el-table-column v-if="tableInfo.selection"
                         width="45"
                         fixed>
          <template slot="header">
            <input type="checkbox"
                   v-model="checkAll"
                   @change="checkAllClick">
          </template>
          <template slot-scope="scope">
            <input type="checkbox"
                   v-model="ckeckVal[scope.$index]"
                   @change="checkboxOnclick(scope.$index,scope.row)">
          </template>
        </el-table-column>
        <el-table-column type="index"
                         label="序号"
                         width="60"
                         fixed="left">
        </el-table-column>
        <template v-for="item of tableInfo.fieldList">
          <el-table-column v-if="item.childBase"
                           :key="item.value"
                           :label="item.label"
                           :align="item.align||'center'"
                           :sortable="item.sortable ">
            <template v-for="item2 of item.childBase">
              <el-table-column :key="item2.value"
                            :label="item2.label"
                            :prop="item2.value"
                            :show-overflow-tooltip="item2.type!=='button'?true:false"
                            :width="item2.width"
                            :align="item2.align||'center'"
                            :fixed="item2.fixed"
                            :sortable="item2.sortable">
                <template slot-scope="scope">
                  <!-- 表格列自定义插槽 -->
                  <template>
                    {{ scope.row[item2.value]}}
                  </template>
                </template>
              </el-table-column>
            </template>
          </el-table-column>
          <el-table-column v-else-if="item.show"
                           :key="item.value"
                           :label="item.label"
                           :prop="item.value"
                           :show-overflow-tooltip="item.type!=='button'?true:false"
                           :width="item.width"
                           :align="item.align||'center'"
                           :fixed="item.fixed"
                           :sortable="item.sortable ">
            <template slot-scope="scope">
              <!-- 表格列自定义插槽 -->
              <template v-if="item.type === 'slot'">
                <slot :name="'col-' + item.value"
                      :row="scope.row"
                      :index="scope.$index" />
              </template>
              <template v-else-if="item.type === 'switch'">
                <el-switch v-for="item of tableInfo.btList1"
                           v-model="scope.row.switch"
                           :key="item.event"
                           @change="changeSwitch(scope.$index, scope.row,item.event)">
                  <!-- <i :class="item.icon">{{item.label}}</i> -->
                </el-switch>
              </template>
              <template v-else-if="item.type === 'button'">
                <el-button v-for="e of tableInfo.btList"
                           :key="e.event"
                           :style="e.style"
                           size="mini"
                           @click="TableEvent(scope.$index, scope.row,e.event)">
                  <i :class="e.icon">{{e.label}}</i>
                </el-button>
              </template>
              <template v-else-if="item.type === 'buttonQx'">
                <el-button v-for="e of tableInfo.btList2"
                           :key="e.event"
                           :style="e.style"
                           size="mini"
                           @click="TableEvent(scope.$index, scope.row,e.event)">
                  <i :class="e.icon">{{e.label}}</i>
                </el-button>
              </template>
              <template v-else-if="item.list">
                {{getlistTypeInfo(scope.row[item.value],item.list)}}
              </template>
              <template v-else>
                {{ scope.row[item.value]}}
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <table border="1"
           ref="tableMode_two"
           class="tableMode_two">
      <tr v-for="(data,index) of tableInfo.data"
          :key="data.value">
        <td class="td">
          <div style="width:100%"
               v-if="tableInfo.selection">
            <input type="checkbox"
                   v-model="ckeckVal[index]"
                   @change="checkboxOnclick(index,data)">
          </div>
          <div v-for="item of tableInfo.fieldList"
               :key="item.value">
            <div v-if="item.show==='true'">
              <span class="title">{{item.label}}</span>
              <!-- <span v-if="item.type==='switch'">
                <el-switch v-model="value"
                           active-color="#13ce66"
                           inactive-color="#ff4949"
                           @click="changeSwitch (index, data, event)">
                </el-switch>
              </span> -->
              <span v-if="item.type==='button'">
                <el-button v-for="item of tableInfo.btList"
                           :key="item.event"
                           :style="item.style"
                           size="mini"
                           @click="TableEvent(index, data,item.event)">
                  <i :class="item.icon">{{item.label}}</i>
                </el-button>
              </span>
              <span v-else-if="item.type==='slot'">
                <slot :name="'col-' + item.value"
                      :row="data"
                      :index="index" />
              </span>
              <span v-else-if="item.list">
                {{getlistTypeInfo(data[item.value],item.list)}}
              </span>
              <el-tooltip v-else-if="item.type==='over'"
                          effect="dark"
                          :content="''+data[item.value]"
                          placement="top">
                <el-button style="background:none;padding:0;color:#676a6c;font-size:13px;cursor:auto">
                  <span class="item">{{data[item.value]}}</span>
                </el-button>
              </el-tooltip>
              <span class="item"
                    :title="data[item.value]"
                    v-else>{{data[item.value]}}</span>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <el-pagination v-if="tableInfo.pager"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   background
                   :small="true"
                   style="margin-top:10px"
                   :current-page="filterInfo.pageNum"
                   :page-sizes="[50, 100, 300, 500]"
                   :page-size="filterInfo.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="tableInfo.total">
    </el-pagination>
    <div v-if="!tableInfo.pager && !tableInfo.showSum1"
         v-show="!tableInfo.accessShow"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录。
    </div>
    <div v-if="tableInfo.showNum2"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录,合计平方数{{tableInfo.selectListData.squareNumbers}},合计体积{{tableInfo.selectListData.volume}}。
    </div>
    <div v-if="tableInfo.showNum3"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录,合计单面积{{tableInfo.selectListData.squareNumbers}}。
    </div>
    <div v-if="tableInfo.showNum"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录,合计扣杂{{tableInfo.sumData.sumImpurities}},合计净重量{{tableInfo.sumData.sumnetWeigh}},合计实重{{tableInfo.sumData.sumweight}},合计金额{{tableInfo.sumData.price}},合计整单扣额{{tableInfo.sumData.sumpriceAdjust}},合计实付金额{{tableInfo.sumData.sumpayAdjust}}。
    </div>
    <div v-if="tableInfo.showSum"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录
      ,合计净重量{{tableInfo.sumData.sumnetWeigh}},合计扣杂{{tableInfo.sumData.sumImpurities}},合计实重{{tableInfo.sumData.sumweight}}。
      <!-- ,合计车数{{tableInfo.sumData.sumcountShipCar}}。 -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'BoyoTable',
  props: {
    tableInfo: Object,
    filterInfo: Object,
    listTypeInfo: Object
  },
  data () {
    return {
      // mark: true,
      checkboxList: [],
      ckeckVal: [],
      checkAll: false,
      maxHeight: null
    }
  },
  watch: {
    'tableInfo.mode' (val) {
      let screenWidth = document.body.clientWidth
      if (screenWidth <= 960) {
        this.$refs.tableMode_one.style.cssText = this.$refs.tableMode_one.style.display === 'block' ? 'display:none' : 'display: block'
        this.$refs.tableMode_two.style.cssText = this.$refs.tableMode_two.style.display === 'none' ? 'display: table' : 'display: none'
      } else {
        this.$refs.tableMode_one.style.cssText = this.$refs.tableMode_one.style.display === 'none' ? 'display:block' : 'display: none'
        this.$refs.tableMode_two.style.cssText = this.$refs.tableMode_two.style.display === 'table' ? 'display: none' : 'display: table'
      }
      this.$refs.tableMode_two.style.width = '100%'
    },
    'tableInfo.selectReset' (val) {
      this.checkboxList = []
      this.ckeckVal = []
      this.checkAll = false
      this.$emit('handleSelectionChange', this.checkboxList)
    }
  },
  mounted () {
    // console.log(this.ckeckVal);
    this.$emit('update:refObj', this.$refs.table)
    if(document.body.clientHeight){
      this.maxHeight = document.body.clientHeight - (this.tableInfo.marginTop ? this.tableInfo.marginTop : 0) - this.$refs.table.$el.offsetTop - 200 + 'px'
    }else{
      this.maxHeight = '500px'
    }
  },
  methods: {
    getlistTypeInfo (val, list) {
      for (let i in this.listTypeInfo[list]) {
        if (val === this.listTypeInfo[list][i].value) {
          return this.listTypeInfo[list][i].label
        }
      }
    },
    // 原生checkbox事件
    checkboxOnclick (index, data) {
      let ckeckVal = this.ckeckVal
      const arr = JSON.parse(JSON.stringify(this.checkboxList))
      if (ckeckVal[index]) {
        this.checkboxList.push(data)
      } else {
        for (let i in this.checkboxList) {
          if (this.checkboxList[i].id === data.id) {
            arr.splice(i, 1)
            break
          }
        }
        this.checkboxList = arr
      }
      if (this.checkboxList.length === this.tableInfo.data.length) {
        this.checkAll = true
      } else if (this.checkboxList.length === 0) {
        this.checkAll = false
      }
      this.$emit('handleSelectionChange', this.checkboxList)
    },
    // 全选
    checkAllClick () {
      let checkAll = this.checkAll
      let ckeckVal = this.ckeckVal
      let data = this.tableInfo.data
      if (checkAll) {
        for (let i in data) {
          ckeckVal[i] = true
        }
        this.checkboxList = data
      } else {
        for (let i in data) {
          ckeckVal[i] = false
        }
        this.checkboxList = []
      }
      this.$emit('handleSelectionChange', this.checkboxList)
    },
    // 表格单选框事件
    handleSelectionChange (val) {
      this.$emit('handleSelectionChange', val)
    },
    selectChange () {
      this.$emit('selectChange', val)
    },
    tableRowClassName({row, rowIndex}){//背景色
      if (this.tableInfo.rowStyle && row.tFlag && row.tFlag == 2) {
        return {
          color: '#ff0000 !important',
          // background: '#f5f9f2'
        }
      }
    },
    // 表格行单击事件
    rowClick (row) {
      this.$emit('TableEvent', 'null', row, 'rowClick')
    },
    // 表格行双击事件
    rowDblclick (row, column, event) {
      this.$emit('TableEvent', row, column, 'rowDblclick')
    },
    // 表格内部按钮事件
    changeSwitch (index, row, event) {
      this.$emit('changeSwitch', index, row, event)
    },
    TableEvent (index, row, event) {
      this.$emit('TableEvent', index, row, event)
    },
    handleSizeChange (pageSize) {
      this.$emit('handleSizeChange', pageSize)
    },
    handleCurrentChange (pageNum) {
      this.$emit('handleCurrentChange', pageNum)
    }
  }
}
</script>
<style lang="stylus" scoped>
.td
  border 1px dashed #000
</style>  



// WEBPACK FOOTER //
// src/components/BoyoTable/index.vue